import { createContext, useContext } from 'react';

export type ContainerContextProps = {
    openSidebar: () => void;
    closeSidebar: () => void;
};

export const ContainerContext = createContext<ContainerContextProps>({
    openSidebar: () => {
        return;
    },
    closeSidebar: () => {
        return;
    }
});

export const useOpenSidebar = () => {
    const { openSidebar } = useContext(ContainerContext);
    return openSidebar;
};
